export default __webpack_public_path__ + "static/psg-feature-background-461db93d34ff0535e8531b05433dead7.png";